<template>
  <!------新增弹框------>
  <dialogWrap
    :dialogShow="handelDialogVisible"
    :title="dialogTitle"
    :before-close="closeDialog"
    :width="'824px'"
  >
    <el-form
      :model="formData"
      ref="formData"
      label-width="140px"
      :rules="serviceRules"
      class="formData"
      :disabled="isDisabled"
    >
      <el-form-item class="mt5" label="营业执照:" label-width="150px">
        <div class="upload">
          <UploadCommon
            :fileList="businessLicenseImgList"
            fileTitle="营业执照"
            :isAlone="true"
            @uploadSuccess="businessLicenseImgMainSuccess"
            :sizeType="4"
            commonUpload
            group="assert"
            code="assert_business_license_toOcr"
          />
        </div>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" label="服务商名称:">
            <el-input v-model="formData.name" placeholder="请输入" clearable v-deleteEmoji></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="serviceType" label="服务类型:">
            <el-select placeholder="请选择" v-model="formData.serviceType" clearable :disabled="!!serviceTypeProp">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="creditCode" label="统一社会信用代码:">
            <el-input
              v-model="formData.creditCode"
              placeholder="请输入"
              maxlength="18"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="legalPersonName" label="法人姓名:">
            <el-input
              v-model="formData.legalPersonName"
              placeholder="请输入"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="registeredAddress" label="注册地址:">
            <el-input
              type="text"
              v-model="formData.registeredAddress"
              placeholder="请输入"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="contacts" label="联系人:">
            <el-input
              v-space="true"
              v-model="formData.contacts"
              placeholder="请输入"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="contactTel" label="联系电话:">
            <el-input
              v-number:phone
              v-model="formData.contactTel"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="address" label="联系地址:">
            <el-input
              type="textarea"
              v-model="formData.address"
              placeholder="请输入"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="remarks" label="备注">
            <el-input
              type="textarea"
              v-model="formData.remarks"
              placeholder="请输入"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <div class="mt16" style="text-align: right">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          v-if="!isDisabled"
          @click="submit"
          type="primary"
          size="small"
          :loading="loading"
        >确认{{type==='edit'?'编辑':'新增'}}</el-button>
      </div>
    </template>
  </dialogWrap>
</template>
<script>
import { providerAdd, providerEdit, ocrBizLicenseV2 } from '@/api/domain/organize'
import SelectOption from '@/store/dict/selectOptionDict'
import { getIdentity, validateAccountCustomerName } from '@/utils/extendFormVaildate'

const TYPE = {
  // 新增
  add: 'add',
  // 编辑
  edit: 'edit',
}

export default {
  name: 'handleProvider',
  props: {
    type: {
      type: String,
      default: TYPE.add,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
    serviceTypeProp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDisabled: false,
      businessLicenseImgList: [],
      formData: {
        id: '',
        name: '',
        serviceType: '',
        contacts: '',
        contactTel: '',
        creditCode: '',
        legalPersonName: '',
        address: '',
        remarks: '',
        businessLicenceUrl: '', // 营业执照url
        registeredAddress: '', // 注册地址(OCR
      },
      serviceRules: {
        name: [
          { required: true, message: '服务商名称不能为空', trigger: 'blur' },
          { validator: validateAccountCustomerName, trigger: 'blur' },
        ],
        serviceType: [
          { required: true, message: '服务类型不能为空', trigger: 'change' },
        ],
        contacts: [
          { validator: validateAccountCustomerName, trigger: 'blur' },
        ],
        // 统一社会信用代码
        creditCode: [
          { required: true, message: '统一社会信用代码不能为空', trigger: 'blur' },
          { validator: getIdentity, trigger: 'blur' },
        ],
      },
      loading: false,
      handelDialogVisible: false,
    }
  },
  computed: {
    // 服务商类型
    typeList() {
      return this.dictParseList(SelectOption.serviceProviderTypeDict)
    },
    // 标题
    dialogTitle() {
      if (this.isDisabled) return '服务商详情'
      if (this.type === TYPE.edit) return '编辑服务商'
      return '新增服务商'
    },
  },
  methods: {
    // orc成功事件
    businessLicenseImgMainSuccess(url) {
      this.formData.businessLicenceUrl = url
      ocrBizLicenseV2({ imageUrl: url }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { enterpriseName, legalName, licenceNo, address } = data
          if (enterpriseName) this.formData.name = enterpriseName
          if (legalName) this.formData.legalPersonName = legalName
          if (licenceNo) this.formData.creditCode = licenceNo
          if (address) this.formData.registeredAddress = address
        }
      })
    },
    submit() {
      this.$refs.formData.validate((valid) => {
        this.formData.businessLicenceUrl = this.getUoloadCommonFileData(this.businessLicenseImgList)
        if (valid) {
          this.type === TYPE.add ? this.addService(this.formData) : this.submitEdit(this.formData)
        }
      })
    },
    // 新增保存
    async addService(val) {
      this.loading = true
      providerAdd(val).then((res) => {
        const { code } = res || {}
        if (code === 1) {
          this.$message({
            message: '新增成功',
            type: 'success',
          })
          this.closeDialog()
          this.$emit('handleSuccess')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 编辑保存
    async submitEdit(val) {
      this.loading = true
      providerEdit(val).then((res) => {
        const { code } = res || {}
        if (code === 1) {
          this.$message({
            message: '编辑成功',
            type: 'success',
          })
          this.closeDialog()
          this.$emit('handleSuccess')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    closeDialog() {
      this.handelDialogVisible = false
      this.businessLicenseImgList = []
      this.$refs.formData.resetFields()
      this.activeNames = ['1']
      Object.keys(this.formData).forEach((item) => {
        this.formData[item] = ''
      })
    },
  },
  watch: {
    handelDialogVisible(val) {
      if (val && this.type === TYPE.edit) {
        if (this.editData.businessLicenceUrl) {
          this.businessLicenseImgList = this.getURL({ data: this.editData.businessLicenceUrl, needName: true })
        }

        Object.keys(this.formData).forEach((key) => {
          this.formData[key] = this.editData[key]
        })
      }
      if (val && this.serviceTypeProp) {
        this.formData.serviceType = Number(this.serviceTypeProp)
      }

      if (this.editData.supportUpdate === 2) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.formData {
  ::v-deep .el-input--small {
    width: 200px;
  }
}
.mt5 {
  margin-top: 5px;
}
::v-deep .el-collapse {
  border-bottom: none;
  border-top: none;
}
::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}
::v-deep .el-collapse-item__header {
  border-top: 1px solid #ececf4;
  border-bottom: none;
  font-size: 14px;
  color: #979899;
}
::v-deep .el-collapse-item__content {
  border-top: 1px solid #ececf4;
  border-bottom: none;
  font-size: 14px;
  color: #979899;
  padding: 0;
}
::v-deep .el-collapse-item__arrow.is-active {
  transform: rotate(-90deg);
}
::v-deep .el-collapse-item__arrow {
  transform: rotate(90deg);
}
</style>
